import React, { useEffect } from 'react';
import { notification, Icon } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { REMOVE_ERROR } from '../../Redux/constants/constants';

const ErrorNotifier = () => {
  const dispatch = useDispatch();
  const errors = useSelector((state) => state.errors);

  useEffect(() => {
    if (errors.length > 0) {
      openNotificationWithIcon(errors[errors.length - 1]);
    }
  }, [errors]);

  const openNotificationWithIcon = (error) => {
    const args = {
      message: error.title,
      description: error.content,
      duration: 5,
      icon: <Icon type="frown" theme="twoTone" twoToneColor="#eb2f96" />,
      onClose: () => {
        dispatch({
          type: REMOVE_ERROR,
        });
      },
    };
    notification.open(args);
  };
  return null;
};

export default ErrorNotifier;
